import React, { useEffect, useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import { Button } from '@mui/material';
import { InformationChip, useModal } from '@europrocurement/flexy-components';
import { useOfferContext } from '../../providers';
import { Offer } from '../../hooks';
import { SelectOfferModal } from '../SelectOfferModal';

export type PrescriberOfferChipProps = {
    tiersId: number;
    onOfferUpdate?: () => void;
};

const PrescriberOfferChip: React.FunctionComponent<PrescriberOfferChipProps> = function (props) {
    const { tiersId, onOfferUpdate } = props;
    const [currentOffer, setCurrentOffer] = useState<Offer | undefined>();
    const [currentOfferLoaded, setCurrentOfferLoaded] = useState<boolean>(false);
    const { offers, offerDataLoaded, getTiersCurrentOffer, setTiersCurrentOffer } =
        useOfferContext();
    const { modalActions } = useModal();

    const onSubmitSelectOffer = async (offer?: Offer) => {
        setCurrentOffer(offer);
        try {
            await setTiersCurrentOffer(tiersId, offer?.id);
            enqueueSnackbar("La modification de l'offre a bien été enregistrée");
            modalActions.close();
            if (onOfferUpdate) {
                onOfferUpdate();
            }
        } catch (e) {
            modalActions.close();
            console.error(e);
            enqueueSnackbar(
                "Une erreur est survenue lors de la modification de l'offre pour ce prescripteur",
                { variant: 'error' },
            );
        }
    };

    const handleShowModal = () => {
        modalActions.call(
            <SelectOfferModal
                onSubmit={onSubmitSelectOffer}
                offers={offers}
                currentOffer={currentOffer}
            />,
        );
    };

    useEffect(() => {
        if (!offerDataLoaded) {
            return;
        }
        (async () => {
            const offer = await getTiersCurrentOffer(tiersId as number);
            setCurrentOffer(offer);
            setCurrentOfferLoaded(true);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tiersId, offerDataLoaded]);

    const label =
        currentOffer?.libelle ?? (currentOfferLoaded ? 'Aucune offre configurée' : 'Chargement...');
    const buttonStyle = {
        marginRight: '16px',
        padding: '0px',
        opacity: currentOfferLoaded ? '1' : '0.4',
    };

    return (
        <Button
            data-testid="BooleanChip-test-id"
            sx={buttonStyle}
            onClick={handleShowModal}
        >
            <InformationChip
                color={currentOffer ? 'primary' : 'secondary'}
                label={label}
                icon={['fasl', 'star-circle']}
            />
        </Button>
    );
};

export default PrescriberOfferChip;
